import React from "react";

const AllFriends = () => {
  return (
    <div>
      <h1>AllFriends</h1>
    </div>
  );
};

export default AllFriends;
